import { FaArrowLeft } from "react-icons/fa";
import PdfIcon from '../Assets/PdfIcon.png';
import Excel from '../Assets/Excel.png';
import video from '../Assets/video.png';
import { BsDownload } from "react-icons/bs";

const FileView  = ({selectedFile,setSelectedFile})=>{

   const mimeType = selectedFile?.mimeType?.toLowerCase();
  const isVideo = mimeType?.includes("video");
  const isImage = mimeType?.includes("image");
  const isPDF = mimeType?.includes("pdf");
  const isAudio = mimeType?.includes("audio");
  const isExcel = mimeType?.includes("excel") || mimeType?.includes("spreadsheetml");
  

 const handleDownload = (fileUrl) => {
    if (!fileUrl) {
      alert("Download URL is missing!");
      return;
    }

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileUrl.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
   <div className='fixed inset-0 flex justify-end bg-black bg-opacity-25 z-50'>
  <div className='h-screen w-full md:w-1/3 bg-white shadow-2xl p-6 rounded-l-lg overflow-y-auto'>
    
    {/* Back Button */}
    <div className="mb-4">
      <button 
        className='text-sm text-gray-600 hover:text-black flex items-center gap-2 transition'
        onClick={() => setSelectedFile(null)}
      >
        <FaArrowLeft className="text-base" />
        <span>Back</span>
      </button>
    </div>

    {/* File Viewer */}
    <div className="w-full h-[250px] flex flex-col items-center justify-center gap-3 bg-gray-100 rounded-md shadow-inner">
  {isVideo ? (
    <video
      controls
      className="object-cover w-full h-full rounded"
      src={selectedFile.url}
    />
  ) : isImage ? (
    <img
      className="w-full h-full object-contain rounded-md"
      src={selectedFile.url}
      alt={selectedFile.name}
    />
  ) : isPDF ? (
    <div className="flex flex-col items-center">
      <img src={PdfIcon} alt="PDF" className="w-20 h-20 object-contain mb-2" />
    </div>
  ) : isExcel ? (
    <div className="flex flex-col items-center">
      <img src={Excel} alt="Excel" className="w-20 h-20 object-contain mb-2" />
    </div>
  ) : isAudio ? (
    <div className="flex flex-col items-center">
      <audio
        controls
        className="w-full"
        src={selectedFile.url}
      />
    </div>
  ) : (
    <div className="text-gray-500 text-center">Unsupported file format</div>
  )}
</div>


    {/* File Info Section */}
    <div className='p-4 text-left'>
      <div className='mt-3'>
        <h2 className='text-lg font-semibold text-gray-800'>Name:</h2>
        <p className='text-gray-700 text-base'>{selectedFile?.name || "name"}</p>
      </div>
      <div className='mt-3'>
        <span className='text-lg font-semibold text-gray-800'>Updated At:</span>
        <p className='text-gray-600'>{new Date(selectedFile?.updatedAt).toLocaleDateString() || "updatedAt"}</p>
      </div>
      <div className='mt-3'>
        <span className='text-lg font-semibold text-gray-800'>File Type:</span>
        <p className='text-gray-600'>{selectedFile?.mimeType || "FileType"}</p>
      </div>
    </div>

    {/* Download Button */}
    <div className='mt-5 px-4'>
      <button
        onClick={() => handleDownload(selectedFile?.url)}
        className='w-full border border-gray-300 px-5 py-2 rounded-md text-lg font-semibold text-gray-700 hover:bg-gray-100 transition'
      >
        Download
      </button>
    </div>

  </div>
</div>

  )
}

export default FileView   